import { GET_MY_TEAM, GET_MY_TEAM_SUCCESS, GET_MY_TEAM_FAILURE } from './types';

export const getMyTeamAction = () => ({
	type: GET_MY_TEAM,
});

export const getMyTeamSuccessAction = (payload: any) => ({
	type: GET_MY_TEAM_SUCCESS,
	payload,
});

export const getMyTeamFailureAction = (error: Error) => ({
	type: GET_MY_TEAM_FAILURE,
	payload: error,
});
